__turbopack_context__.v({
  "className": "editorialnew_b9e02533-module__Kwd3eG__className",
  "variable": "editorialnew_b9e02533-module__Kwd3eG__variable",
});
